import { render, staticRenderFns } from "./GenericMovieCard.vue?vue&type=template&id=247df58e&scoped=true"
import script from "./GenericMovieCard.vue?vue&type=script&lang=js"
export * from "./GenericMovieCard.vue?vue&type=script&lang=js"
import style0 from "./GenericMovieCard.vue?vue&type=style&index=0&id=247df58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247df58e",
  null
  
)

export default component.exports